import angular from 'angular';
import uiRouter from 'angular-ui-router';

import memberComplianceComponent from './member-compliance.component';
import memberComplianceService from './member-compliance.service';
import compliantMembers from './compliant-members/compliant-members.module';
import nonCompliantMembers from './noncompliant-members/noncompliant-members.module';

export default
  angular.module('components.admin.member-compliance', [
    uiRouter,
    compliantMembers,
    nonCompliantMembers
  ])
    .component('memberCompliance', memberComplianceComponent)
    .service('MemberComplianceService', memberComplianceService)
    .config(($stateProvider) => {
      'ngInject';

      $stateProvider
        .state('memberCompliance', {
          parent: 'memberComplianceProcess',
          url: '/member-compliance',
          component: 'memberCompliance',
          resolve: {
            compliantCompanies: MemberComplianceService =>
              MemberComplianceService.getCompliantCompanies().then(r => r.data),
            nonCompliantCompanies: MemberComplianceService =>
              MemberComplianceService.getNonCompliantCompanies().then(r => r.data)
          }
        });
    })
    .name;



// WEBPACK FOOTER //
// ./components/app/admin/member-compliance/member-compliance.module.js